<template>
  <nx-renderless-search id="renderLess"
                        entity="category"
                        :filters="filters"
                        :limit="100"
                        :sort="sort"
                        v-on="$listeners"
                        ref="tags">
    <template slot-scope="{ items, loadMore, hasMorePages, loading, hasResults }">
      <v-list v-if="hasResults" dark class="pt-0">
        <template v-for="item in items">
          <nx-bag-list-item :id="item.entityId || item.id"
                            :key="item.entityId || item.id"
                            :text="item.entity ? item.entity.name : item.name"
                            icon="folder"
                            @click="$listeners.click(item.entity ? item.entity : item)">
          </nx-bag-list-item>
        </template>
        <v-btn
          v-if="hasMorePages"
          :disabled="loading"
          :loading="loading"
          block
          @click="loadMore()"
          flat>
          {{ $t('message.common.loadMore') }}
        </v-btn>
      </v-list>
      <nx-bag-empty-item v-else-if="!loading" :text="$t('message.bag.noTags')"></nx-bag-empty-item>
    </template>
  </nx-renderless-search>
</template>

<script>
import NxRenderlessSearch from '@/modules/searcher/RenderlessSearcher';
import NxBagListItem from '../common/BagListItem';
import NxBagEmptyItem from '../common/BagEmptyItem';

export default {
  components: {
    NxRenderlessSearch,
    NxBagListItem,
    NxBagEmptyItem,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    sort: {
      type: Object,
    },
  },
  methods: {
    appendNewTag(tag) {
      this.$refs.tags.appendItem(tag);
    },
  },
};
</script>
